import styled$1 from 'styled-components';
import { colorSet } from '@ccg/core';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';

const StyledLogo = styled$1.svg`
  display: ${props => props.inline ? 'inline-block' : 'block'};
  fill: ${colorSet('color')};
  width: auto;
  height: ${props => props.size === 'small' ? '17px' : '32px'};
`;

const Logo = ({
  size,
  inline,
  className
}) => /*#__PURE__*/React$1.createElement(StyledLogo, {
  inline: inline,
  size: size,
  className: className,
  width: "821",
  height: "158",
  viewBox: "361 -29 821 158"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M1083.4 123.8l-52.3-103.3v-45.7H1182v148.9h-98.6zM961.9 32.1l37.5 52.1-19.7 39.5h-4.1l-52.2-75.3v-.9l59.2-56.3-13.1-6.1v-9.8h50.1v10.5l-11.3 4.1-46.4 42.2zm-43.1 78.1l14.5 3v10.5h-75.2v-10.2l13.3-2.6V-6.2l-13.3-8.6v-9.8h75.2v10.5L918.8-10v120.2zm-168.2-53h-13.2v53l15.8 3v10.5h-78.7v-10.2l14.7-3.2v-119l-14.7-6.1v-9.8c8.1 0 17.7-.1 24.4-.3 6.7-.2 12.8-.4 18.2-.5 2.3 0 5.3-.1 8.7-.2 3.5-.2 7-.3 10.7-.4 3.7-.1 7.2-.3 10.6-.4 3.4-.2 6.3-.2 8.6-.2 9.7 0 18.7.5 26.9 1.6s15.2 3 21.2 5.8 10.6 6.6 13.9 11.5c3.3 4.9 5 11 5 18.4 0 4.8-.9 9.2-2.5 13.3-1.7 4.1-4 7.8-7 11.1-3 3.4-6.4 6.3-10.4 8.8-4 2.6-8.3 4.7-12.8 6.4 6.2 9.6 12.8 19.6 20 29.9 7.2 10.3 14.5 20.4 22 30.1l11.8 3.3v10.3h-49.2l-44-66.7zm26.2-52.4c-1.1-4.1-2.8-7.6-5.2-10.7-2.3-3-5.3-5.5-8.7-7.3-3.5-1.8-7.6-2.7-12.5-2.7-2.5 0-5 .1-7.4.3-2.4.2-4.3.5-5.6.7v60.5h8.4c6.2 0 11.4-.7 15.6-2.2 4.2-1.5 7.5-3.5 10.1-6 2.5-2.5 4.3-5.5 5.4-8.8 1.1-3.4 1.7-7 1.7-10.9-.1-4.5-.7-8.8-1.8-12.9zM640 105.1c-7.6 7.5-16.9 13.3-28.1 17.6-11.1 4.2-23.9 6.3-38.3 6.3-12.7 0-23.8-2.1-33.5-6.2s-17.7-9.8-24.2-16.9c-6.5-7.1-11.4-15.3-14.7-24.7-3.3-9.3-5-19.1-5-29.5 0-12.2 2.3-23.3 6.9-33.2 4.6-9.9 10.8-18.4 18.8-25.4s17.3-12.5 28.1-16.4c10.8-3.9 22.2-5.8 34.5-5.8 12.1 0 23 1.7 32.6 5.1 9.7 3.4 17.9 8.3 24.8 14.7 6.8 6.4 12.1 14.2 15.8 23.4 3.7 9.2 5.5 19.4 5.5 30.8 0 12-2 23.2-5.9 33.5-3.9 10.3-9.7 19.2-17.3 26.7zm-22.8-77.2c-1.2-8.5-3.4-16-6.5-22.4-3.2-6.4-7.5-11.5-13-15.2-5.5-3.7-12.6-5.6-21.3-5.6-6 0-11.3 1.6-15.8 4.8-4.6 3.3-8.3 7.5-11.3 12.8-2.9 5.3-5.1 11.5-6.5 18.5-1.4 7.1-2.1 14.5-2.1 22.4 0 22.8 3.6 40.4 10.9 52.7 7.3 12.3 17.4 18.4 30.4 18.4 7.2 0 13.2-1.8 17.9-5.5 4.7-3.6 8.5-8.3 11.3-14 2.8-5.7 4.8-12 6-19 1.2-7 1.8-13.9 1.8-20.7-.1-9.6-.7-18.7-1.8-27.2zM478.3 8l-16.7-19.4h-38v51.9h30.2l11-13.7 5.1 1.8.1 41.8-6.2 1.5-9.9-16h-30.3V110l17.3 4.2v9.4H361v-9.1l15.3-4.9V-10.5L361-16.1v-8.7h123.3V4.7l-6 3.3z"
}));

Logo.propTypes = {
  inline: PropTypes$1.bool,
  size: PropTypes$1.oneOf(['small', 'large']),
  className: PropTypes$1.string
};
Logo.defaultProps = {
  inline: false,
  size: 'small',
  className: ''
};

export default Logo;
